import React, { Component } from "react";

import {
  Alert,
  TouchableOpacity,
  Content,
  View,
  Icon,
  Image,
  ImageUpload,
  Modal,
  Navigator,
  Progress,
  Text,
  TextInput,
  StyleSheet
} from "react-1app";
import { Model } from "../infra";

import * as actions from "../redux/actions.js";

export default class AddNovidades extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_local: new Model("user_local"),
      usuario: new Model("usuario"),
      novidades: new Model("novidades")
    };
    Navigator.cloneState(this);
  }

  salvar() {
    if (!this.state.novidades.titulo) {
      Alert.alert("Atenção", "Por favor, digite um título");
      return;
    }
    if (!this.state.novidades.descricao) {
      Alert.alert("Atenção", "Por favor, digite uma descrição");
      return;
    }
    if (!this.state.novidades.corpo) {
      Alert.alert("Atenção", "Por favor, digite um texto");
      return;
    }
    this.setState({ save: true });
    if (this.state.novidades.objectId == undefined) {
      actions.novidadeInsert(this.state.novidades, ret => {
        console.log(ret, "insert");
        this.setState({ save: false });
        this.state.navigator.closeModal();
      });
    } else {
      actions.novidadeUpdate(
        this.state.novidades,
        this.state.novidades.objectId,
        ret => {
          console.log(ret, "update");
        }
      );
      this.setState({ save: false });
      this.state.navigator.closeModal();
    }
  }

  deleteDeletar() {
    Alert.alert("Deletar", "Deletar esta Novidade?", [
      {
        text: "Não",
        onPress: null
      },
      {
        text: "Sim",
        onPress: () => {
          actions.novidadeDelete(this.state.novidades._id, data => {
            //TODO recarregar
            this.state.navigator.closeModal();
            this.props.activity.queryNovidades();
          });
        }
      }
    ]);
  }

  componentDidMount() {
    this.unsubscribe = this.props.screenProps.store.subscribe(() => {
      this.setState(this.props.screenProps.store.getState());
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    return (
      <Content style={styles.content}>
        <View style={styles.view}>
          <View style={styles.view1}>
            {this.state.save ? (
              <View style={styles.view2}>
                <Progress style={styles.progress} />
              </View>
            ) : null}

            <TouchableOpacity
              style={styles.salvar}
              onPress={() => {
                this.salvar();
              }}
            >
              <Icon
                style={styles.icon5}
                fromFontFamily={"Material Icons"}
                name={"save"}
              />
            </TouchableOpacity>

            {this.state.novidades.objectId ? (
              <TouchableOpacity
                style={styles.deletar}
                onPress={() => {
                  this.deleteDeletar();
                }}
              >
                <Icon
                  style={styles.icon4}
                  fromFontFamily={"Material Icons"}
                  name={"delete"}
                />
              </TouchableOpacity>
            ) : null}
          </View>
          <View style={styles.view3}>
            <View style={styles.view7}>
              <Text style={styles.text11}>{"Imagem:"}</Text>
              <ImageUpload
                style={styles.imageupload}
                value={this.state.novidades.imagem}
                onChange={value => {
                  console.log(value);
                  this.state.novidades.imagem = value;
                  this.setState({ this: this.state.this });
                }}
              />
            </View>
            <View style={styles.view4}>
              <Text style={styles.text}>{"Título:"}</Text>
              <TextInput
                style={styles.textinput17}
                value={this.state.novidades.titulo}
                onChange={value => {
                  this.state.novidades.titulo = value;
                  this.setState({ this: this.state.this });
                }}
                keyboardType={"default"}
                multiline={true}
                ref={v => (this.textinput17 = v)}
              />
              <Text style={styles.text12}>{"Descrição:"}</Text>
              <TextInput
                style={styles.textinput19}
                value={this.state.novidades.descricao}
                onChange={value => {
                  this.state.novidades.descricao = value;
                  this.setState({ this: this.state.this });
                }}
                keyboardType={"default"}
                multiline={true}
                ref={v => (this.textinput19 = v)}
              />
              <Text style={styles.text1}>{"Corpo:"}</Text>
              <TextInput
                style={styles.textinput18}
                value={this.state.novidades.corpo}
                onChange={value => {
                  this.state.novidades.corpo = value;
                  this.setState({ this: this.state.this });
                }}
                keyboardType={"default"}
                multiline={true}
                ref={v => (this.textinput18 = v)}
              />
            </View>
          </View>
        </View>
      </Content>
    );
  }
}

var styles = StyleSheet.create({
  content: {
    backgroundColor: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row",
    flex: 1
  },
  view: {
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    flexWrap: "nowrap",
    margin: 10
  },
  view1: {
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    flexWrap: "nowrap",
    paddingRight: 40
  },
  view2: {
    alignSelf: "auto",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row",
    flex: 0
  },
  progress: {
    width: 35,
    height: 35
  },
  salvar: {
    alignSelf: "auto",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    flexDirection: "row-reverse",
    width: 50,
    borderRadius: 25,
    backgroundColor: "rgba(255,135,0,1)",
    marginRight: 15
  },
  icon5: {
    color: "rgba(255,255,255,1)",
    fontSize: 25
  },
  deletar: {
    alignSelf: "auto",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    flexDirection: "row-reverse",
    flexWrap: "nowrap",
    width: 50,
    borderRadius: 25,
    borderColor: "rgba(0,0,0,0)",
    backgroundColor: "rgba(255,135,0,1)"
  },
  icon4: {
    color: "rgba(255,255,255,1)",
    fontSize: 25
  },
  view3: {
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  view7: {
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    marginTop: 5,
    margin: 15
  },
  text11: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontWeight: "normal",
    marginTop: 10
  },
  imageupload: {
    width: 100,
    height: 50,
    alignSelf: "auto",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  view4: {
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    margin: 15,
    marginTop: 20
  },
  text: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontWeight: "normal",
    marginTop: 10
  },
  textinput17: {
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    textAlign: "left",
    fontWeight: "normal",
    marginTop: 5,
    marginRight: 30,
    maxHeight: 400,
    minHeight: 30,
    minWidth: 400,
    flexWrap: "nowrap"
  },
  text12: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontWeight: "normal",
    marginTop: 10
  },
  textinput19: {
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    textAlign: "left",
    fontWeight: "normal",
    marginTop: 5,
    marginRight: 30,
    flexWrap: "nowrap"
  },
  text1: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontWeight: "normal",
    marginTop: 10
  },
  textinput18: {
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    textAlign: "left",
    fontWeight: "normal",
    marginTop: 5,
    marginRight: 30,
    flexWrap: "nowrap"
  }
});



// WEBPACK FOOTER //
// ./src/views/AddNovidades.js